import { FileZipOutlined } from "@ant-design/icons";
import { CheckCard } from "@ant-design/pro-components";
import { Button, Form, Popconfirm, Space, Spin, message } from "antd";
import dayjs from 'dayjs'
import { useState } from "react";
import useBackupRestore from '../controller/BackupRestoreController'
import { useEffect } from "react";
import { useRef } from "react";

export default () => {
    const [form] = Form.useForm();
    const handleSubmit = async (values) => {
        console.log('values', values);
    };
    const [backuping, setBackuping] = useState(false);
    const [restoring, setRestoring] = useState(false);
    const {
        data,
        restoreData,
        getDemoData,
        postDemoData,
        getRestoreData,
        postRestoreData,
    } = useBackupRestore({
        onFinish: ({ axiosMode, status, values }) => {
            if (values?.mode === 'restore') {
                message.success('還原成功')
            } else if (values?.mode === 'backup') {
                message.success('備份成功')
            }
        },
    })
    useEffect(() => {
        setBackuping(false)
        data.forEach(eachItem => {
            if (!eachItem.finish_time) {
                setBackuping(true)
            }
        })
    }, [data])
    useEffect(() => {
        setRestoring(false)
        restoreData.forEach(eachItem => {
            if (!eachItem.finish_time) {
                setRestoring(true)
            }
        })
    }, [restoreData])
    useEffect(() => {
        getRestoreData()
        getDemoData()
    }, [])
    return (<>
        <Form form={form} onFinish={handleSubmit} layout="vertical">
            {backuping && <>
                <Form.Item>
                    <Spin />手動備份進行中...
                </Form.Item>
            </>}
            <Space>
                {!backuping && <Popconfirm
                    placement={'right'}
                    title="提醒"
                    description="確定要手動備份目前的資料嗎？"
                    onConfirm={() => {
                        postDemoData([
                            {
                                "server_name": "172.0.4.232",
                                "user_name": "mil",
                                "password": "7172930",
                                "db_name": "mil_diff",
                                "filename": "mil_test111"
                            }
                        ])
                        setBackuping(true)
                    }}
                >
                    <Button type={'text'} style={{ background: '#FdF9C9' }}>手動備份</Button>
                </Popconfirm>}
                <Form.Item noStyle>
                    {restoring && <>
                        <Form.Item>
                            <Spin />手動還原進行中...
                        </Form.Item>
                    </>}
                    {!restoring && (<>
                        <Popconfirm
                            placement={'right'}
                            title="提醒"
                            description="確定要還原此備份紀錄嗎？"
                            onConfirm={() => {
                                const values = data.find(item => item.backup_id === form.getFieldValue('backup_id'))
                                postRestoreData(
                                    [
                                        {
                                            "server_name": "172.0.4.232",
                                            "user_name": "postgres",
                                            "password": "7172930",
                                            "db_name": "mil_diff",
                                            "filename": values.filename
                                        }
                                    ]
                                )
                                setRestoring(true)
                            }}
                        >
                            <Button type={'text'} style={{ backgroundColor: 'rgba(255, 242, 237, 1)' }}

                            >還原此版本</Button>
                        </Popconfirm>
                    </>)}
                </Form.Item>
            </Space>
            <Form.Item name="backup_id" label="備份紀錄">
                <CheckCard.Group style={{ width: '100%' }}>
                    {data.map(map_item => (<>
                        <CheckCard
                            title={map_item.finish_time ? dayjs(map_item.finish_time).format('YYYY-MM-DD AHH:mm') : '備份中...'}
                            avatar={
                                <FileZipOutlined style={{ fontSize: 24 }} />
                            }
                            description="手動備份"
                            value={map_item.backup_id}
                        />
                    </>))}
                </CheckCard.Group>
            </Form.Item>
        </Form>
    </>)
}